/**
 * @since 1.1.7
 */
export interface IPublicModelSkeletonItem {

}